import { render, staticRenderFns } from "./certificationLetter.vue?vue&type=template&id=74b1c77b&"
import script from "./certificationLetter.vue?vue&type=script&lang=js&"
export * from "./certificationLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports